import React, { useState } from "react";

import { Badge, Menu } from "@mui/material";

import { useAppState } from "../../../context/StateContext";
import LanguagesListDropdown from "./LanguagesListDropdown";
import useStyles from "./styles";

const LanguageBlock = () => {
  const [languageDropdownMenu, setLanguageDropdownMenu] = useState<null | HTMLElement>(null);

  const { activeFlag } = useAppState();

  const classes = useStyles();

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setLanguageDropdownMenu(event.currentTarget);
  };

  const handleClose = () => {
    setLanguageDropdownMenu(null);
  };

  return (
    <div className="top-sidebar">
      <div
        onClick={handleClick}
        className={languageDropdownMenu ? classes.buttonActive : classes.button}
      >
        <Badge invisible={!!languageDropdownMenu}>
          <img
            loading="lazy"
            className={classes.flagImage}
            src={activeFlag ? `https://flagcdn.com/w80/${activeFlag.toLowerCase()}.png` : ""}
            srcSet={activeFlag ? `https://flagcdn.com/w160/${activeFlag.toLowerCase()}.png 2x` : ""}
            alt=""
          />
        </Badge>
      </div>
      <Menu
        anchorEl={languageDropdownMenu}
        keepMounted={false}
        open={Boolean(languageDropdownMenu)}
        onClose={handleClose}
        className={classes.menu}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          className: classes.menuContainer,
        }}
      >
        <LanguagesListDropdown handleClose={handleClose} />
      </Menu>
    </div>
  );
};

export default LanguageBlock;
